import { MetaLayerDefinition, SearchResultFlat } from '@agissc/ktag-map';

export interface ToolbarState {
  isOpen: boolean;
  isToolbarExtensionOpen: boolean;
}

export enum FlyinNames {
  Legends = 'legends',
  Identify = 'identify',
}

export interface Notification {
  id: string;
  message: string;
  title: string;
  type: 'information' | 'positive' | 'negative' | 'highlight' | 'persistent';
}

export enum AccordionName {
  MAP_CONFIGURATION = 'map-configuration',
  DRAW_CONFIGURATION = 'draw-configuration',
  ATTRIBUTESEARCH_CONFIGURATION = 'attribute-search-configuration',
  IDENTIFY_CONFIGURATION = 'identify-configuration',
}

export interface AccordionProps {
  id: string;
  expanded: boolean;
}

export interface UIStateSliceProps {
  toolbar: ToolbarState;
  favorites: Record<string, SearchResultFlat | MetaLayerDefinition>;
  basemapSelectionVisibility: boolean;
  toolDialogWidth: number;
  activeFlyin: FlyinNames | null;
  activeFlyinView: string | null;
  flyinWidth: number;
  viewCollapse: boolean;
  notifications: Notification[];
  disabledNotificationTitle: string[];
  navigationIsEnabled: boolean;
  displayResetNotification: boolean;
  displayStartUpMessage: boolean;
  accordions: Record<AccordionName, AccordionProps[]>;
}

export default interface UIStateSlice extends UIStateSliceProps {
  setToolbar: (input: ToolbarState) => void;
  toggleToolbar: () => void;
  toggleToolbarExtension: () => void;
  toggleFavorite: (item: SearchResultFlat | MetaLayerDefinition) => void;
  toggleBasemapSelectionVisibility: () => void;
  setToolDialogWidth: (input: number) => void;
  setActiveFlyin: (input: FlyinNames | null, view?: string | null) => void;
  setActiveFlyinView: (input?: string | null) => void;
  setFlyinWidth: (input: number) => void;
  toggleViewCollapse: () => void;
  addNotification: (input: Notification) => void;
  removeNotification: (id: string | string[]) => void;
  disableNotificationTitle: (title: string) => void;
  resetNotifications: () => void;
  setNavigationIsEnabled: (value: boolean) => void;
  unsetResetNotification: () => void;
  toggleStartUpMessage: () => void;
  setAccordionItem: (
    accordionName: AccordionName,
    itemId: string,
    expanded: boolean,
  ) => void;
  setAllAccordionItems: (
    accordionName: AccordionName,
    itemIds: string[],
    expanded: boolean,
  ) => void;
  removeAllAccordionItems: (accordionName: AccordionName) => void;
}
